// eslint-disable-next-line @typescript-eslint/no-unused-vars
enum StoreModules {
  ftbot = 'ftbot',
  alerts = 'alerts',
  layout = 'layout',
  uiSettings = 'uiSettings',
}

export default StoreModules;
